import { Button, Grid, Stack, TextField } from '@mui/material';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useQuery } from 'react-query';
import * as api from '../../api/app/opcClientApi';
import { ApiError } from '../../components/core/ApiError/ApiError';
import { Loader } from '../../components/core/Loader/Loader';
import { SelectBoxAutocomplete } from '../../components/core/SelectBox/SelectBoxAutocomplete';
import { OpcClient } from '../../types/app/opcClient.types';
import { dictionary } from '../../utils/core/dictionary';

interface Props {
  setEndpointAddress: any;
  onSubmit: any;
}
export function BrowseOpcUaForm({ setEndpointAddress, onSubmit }: Props) {
  const {
    handleSubmit,
    formState: { errors },
    control,
    register,
    setValue,
  } = useForm<any>();
  const [opcClientList, setOpcClientList] = useState<OpcClient[]>([]);

  const {
    data: _opcClientList,
    isLoading,
    isError,
  } = useQuery<OpcClient[]>('opcClientList', api.getOpcClientList, {
    onSuccess: (res) => {
      let tmpOpcClientList = res.filter(
        (c: OpcClient) => c.endpointAddress && c.endpointAddress.length > 0,
      );
      setOpcClientList(tmpOpcClientList);
    },
  });

  if (isError) return <ApiError />;
  if (isLoading || !_opcClientList) return <Loader />;

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8} lg={4}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <SelectBoxAutocomplete
                label={'OPC client'}
                items={opcClientList}
                valueKey={'endpointAddress'}
                labelKey={'instanceName'}
                onChange={(value: any) => {
                  setValue('endpointAddressInput', value);
                  setEndpointAddress(value);
                }}
                controllerProps={{
                  name: 'endpointAddress',
                  control: control,
                }}
                errors={errors}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label={dictionary.ENDPOINT_ADDRESS}
                {...register('endpointAddressInput')}
                onChange={(e: any) => {
                  setValue('endpointAddress', '');
                  setEndpointAddress(e.target.value);
                }}
                defaultValue={' '}
                error={Boolean(errors.endpointAddress)}
                helperText={errors.endpointAddress?.message}
                autoFocus
              />
            </Grid>
            <Grid item>
              <Stack spacing={2} direction="row">
                <Button type="submit" variant="contained" color="success">
                  {dictionary.SUBMIT}
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
